import { render, staticRenderFns } from "./PaymentAccordion.vue?vue&type=template&id=161545d9"
import script from "./PaymentAccordion.vue?vue&type=script&lang=js"
export * from "./PaymentAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports